import { Icon } from '@chakra-ui/react';

export default function GaugeTactical({ ...props }) {
  return (
    <Icon
      width='14px'
      height='14px'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M10.9598 10.9597C13.1467 8.77278 13.1467 5.22706 10.9598 3.04012C8.77286 0.853184 5.22714 0.853184 3.0402 3.04012C0.853266 5.22706 0.853266 8.77278 3.0402 10.9597'
        stroke='#1353EC'
        strokeWidth='2'
      />
      <path
        d='M0.331377 3.14992C0.717976 2.48031 7.03016 5.40088 7.69977 5.78748C8.36938 6.17408 8.59881 7.03031 8.21221 7.69992C7.82561 8.36953 6.96938 8.59895 6.29977 8.21235C5.63016 7.82575 -0.0552228 3.81953 0.331377 3.14992Z'
        fill='#123790'
      />
    </Icon>
  );
}
